<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 10:58:19
-->
<template>
	<div class="douKuaiCell">
		<div>
			<div>
				<span>{{ row['platform_id'] | formatPlatformName('unify') }}：</span>
				<span>{{ row['anchor_account'] }}</span>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
</style>